<template>
  <div class="columns is-multiline">
    <div class="column is-full-mobile is-6">
      <window title="Basic Selects">
        <div class="columns">
          <div class="column">
            <b-field label="Simple">
              <b-select placeholder="Select a name">
                <option v-for="option in data" :value="option.id" :key="option.id">
                  {{ option.user.first_name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Grouped">
              <b-select placeholder="Select a character" icon="account">
                <optgroup label="Black Sails">
                  <option value="flint">Flint</option>
                  <option value="silver">Silver</option>
                  <option value="vane">Vane</option>
                  <option value="billy">Billy</option>
                  <option value="jack">Jack</option>
                </optgroup>

                <optgroup label="Breaking Bad">
                  <option value="heisenberg">Heisenberg</option>
                  <option value="jesse">Jesse</option>
                  <option value="saul">Saul</option>
                  <option value="mike">Mike</option>
                </optgroup>

                <optgroup label="Game of Thrones">
                  <option value="tyrion-lannister">Tyrion Lannister</option>
                  <option value="jamie-lannister">Jamie Lannister</option>
                  <option value="daenerys-targaryen">Daenerys Targaryen</option>
                  <option value="john-snow">John Snow</option>
                </optgroup>
              </b-select>
            </b-field>

            <b-field label="Error" type="is-danger" message="Something went wrong with this field">
              <b-select placeholder="Select a character">
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field label="Rounded">
              <b-select placeholder="Select a character" rounded>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Required">
              <b-select placeholder="Select a character" required>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field label="Loading">
              <b-select placeholder="Select a character" loading>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field label="Disabled">
              <b-select placeholder="Select a character" disabled>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field class="p-t-md" label="Disabled option">
              <b-select placeholder="Select a character">
                <option value="flint">Flint</option>
                <option value="silver" disabled>Silver</option>
              </b-select>
            </b-field>
          </div>
        </div>

        <b-field label="Expanded">
          <b-select placeholder="Select a character" expanded>
            <option value="flint">Flint</option>
            <option value="silver">Silver</option>
          </b-select>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <div class="columns">
        <div class="column is-half">
          <window title="Sizes">
            <b-field>
              <b-select placeholder="Small" size="is-small" expanded>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field>
              <b-select placeholder="Default" expanded>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field>
              <b-select placeholder="Medium" size="is-medium" expanded>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>

            <b-field>
              <b-select placeholder="Large" size="is-large" expanded>
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
              </b-select>
            </b-field>
          </window>

        </div>
        <div class="column is-half">
          <window title="Multiselect">
            <p class="content">
              <b>Use Ctrl + select</b>: {{ selectedOptions }}</p>
            <b-field>
              <b-select multiple native-size="5" v-model="selectedOptions">
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
                <option value="vane">Vane</option>
                <option value="billy">Billy</option>
                <option value="jack">Jack</option>
                <option value="heisenberg">Heisenberg</option>
                <option value="jesse">Jesse</option>
                <option value="saul">Saul</option>
                <option value="mike">Mike</option>
              </b-select>
            </b-field>
          </window>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <window title="With Material Design Icons">
            <b-field>
              <b-select placeholder="Country" icon="earth">
                <option value="1">Option 1</option>
                <option value="2">Option 2</option>
              </b-select>
            </b-field>

            <b-field>
              <b-select placeholder="Client" icon="account">
                <option value="1">Option 1</option>
                <option value="2">Option 2</option>
              </b-select>
            </b-field>
          </window>
        </div>
        <div class="column is-half">
          <window title="With Font Awesome 5">
            <b-field>
              <b-select placeholder="Country" icon="globe" icon-pack="fas">
                <option value="1">Option 1</option>
                <option value="2">Option 2</option>
              </b-select>
            </b-field>
            <b-field>
              <b-select placeholder="Client" icon="user" icon-pack="fas">
                <option value="1">Option 1</option>
                <option value="2">Option 2</option>
              </b-select>
            </b-field>
          </window>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const data = require('@/assets/data/data_test.json');

export default {
  data() {
    return { data, selectedOptions: [] };
  },
};
</script>
